module.exports = __webpack_public_path__ + "assets/img/36_557.d4a01129.jpg";